import React from 'react';

export const CirculateLogo = ({ className = "", size = 32, showText = true }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Infinity loop logo */}
      <svg 
        width={size} 
        height={size * 0.6} 
        viewBox="0 0 100 60" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer loop */}
        <path
          d="M30 30C30 16.7 40.7 6 54 6C67.3 6 78 16.7 78 30C78 43.3 67.3 54 54 54C47.4 54 41.4 51.3 37 47"
          stroke="#E5A94B"
          strokeWidth="6"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M70 30C70 43.3 59.3 54 46 54C32.7 54 22 43.3 22 30C22 16.7 32.7 6 46 6C52.6 6 58.6 8.7 63 13"
          stroke="#3A8D6E"
          strokeWidth="6"
          strokeLinecap="round"
          fill="none"
        />
        {/* Inner loop */}
        <path
          d="M38 30C38 21.2 45.2 14 54 14C62.8 14 70 21.2 70 30C70 38.8 62.8 46 54 46C49.6 46 45.6 44.2 42.8 41.2"
          stroke="#4B8BC7"
          strokeWidth="5"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M62 30C62 38.8 54.8 46 46 46C37.2 46 30 38.8 30 30C30 21.2 37.2 14 46 14C50.4 14 54.4 15.8 57.2 18.8"
          stroke="#6B4E8D"
          strokeWidth="5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      
      {showText && (
        <span className="font-heading text-xl tracking-tight" style={{ color: '#5C3D2E' }}>
          circulate
        </span>
      )}
    </div>
  );
};

export const CirculateLogoMini = ({ size = 28 }) => {
  return (
    <svg 
      width={size} 
      height={size * 0.6} 
      viewBox="0 0 100 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 30C30 16.7 40.7 6 54 6C67.3 6 78 16.7 78 30C78 43.3 67.3 54 54 54C47.4 54 41.4 51.3 37 47"
        stroke="#E5A94B"
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M70 30C70 43.3 59.3 54 46 54C32.7 54 22 43.3 22 30C22 16.7 32.7 6 46 6C52.6 6 58.6 8.7 63 13"
        stroke="#3A8D6E"
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M38 30C38 21.2 45.2 14 54 14C62.8 14 70 21.2 70 30C70 38.8 62.8 46 54 46C49.6 46 45.6 44.2 42.8 41.2"
        stroke="#4B8BC7"
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M62 30C62 38.8 54.8 46 46 46C37.2 46 30 38.8 30 30C30 21.2 37.2 14 46 14C50.4 14 54.4 15.8 57.2 18.8"
        stroke="#6B4E8D"
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

export default CirculateLogo;
